import { Box, BoxProps, ColorOptions } from '@jfs/ui-new'
import { useCallback, useEffect } from 'react'
import { useWindowDimensions } from 'react-native'
import { Container } from '../../../components/Container'
import { NewTable } from '../../../components/NewTable'
import { useLazyApiData, useStores } from '../../../data/store'
import { getCustomColumnWidth } from '../MyOnboardedEntityQueue'
import { CheckerHeader } from '../OnboardEntity/comps/CheckerHeader'

const Incidents = ({ navigation }: any) => {
  //
  const { getIncidentsAsync } = useStores((store) => ({
    getIncidentsAsync: store.entityOnboarding.getIncidentsAsync,
  }))
  const { width } = useWindowDimensions()

  const [lazyGetIncidentsAsync, getIncidentsHandler] = useLazyApiData(getIncidentsAsync)

  useEffect(() => {
    lazyGetIncidentsAsync()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  console.log('htag getIncidentsHandler', getIncidentsHandler)

  const onRowItemPress = useCallback(
    (item) => {
      navigation?.navigate('onboardingIncidentDetails', { item })
    },
    [navigation],
  )

  return (
    <Box {...styles.container}>
      <CheckerHeader
        title={'Incidents'}
        showCalendar={false}
        showRefresh={getIncidentsHandler?.state === 'fulfilled' && true}
        showSearchByEntityId={false}
        enableFilter={false}
        onRefresh={lazyGetIncidentsAsync}
        fetchDataOnChange={lazyGetIncidentsAsync}
      />
      <Container
        isLoading={getIncidentsHandler?.state === 'pending'}
        errorMessage={getIncidentsHandler?.data?.message}
        emptyMessage={
          getIncidentsHandler?.state === 'fulfilled' && getIncidentsHandler?.data?.length === 0 && 'No Data Found'
        }
        onRetry={lazyGetIncidentsAsync}
        flex={1}>
        <NewTable
          data={getIncidentsHandler?.data ?? []}
          rowHeight={48}
          headerHeight={64}
          height={544}
          customWidthFunc={getCustomColumnWidth}
          tableWidth={width > 1200 ? width - 290 : width}
          headerRowKeys={incidentHeaderKeys}
          onRowClick={onRowItemPress}
          onRetry={lazyGetIncidentsAsync}
        />
      </Container>
    </Box>
  )
}

const incidentHeaderKeys = {
  applicationId: 'Application ID',
  requestType: 'Request Type',
  createdAt: 'Creation Date & Time',
  applicationStatus: 'Status',
}

export default Incidents

const styles = {
  container: {
    h: '100%',
    borderRadius: 8,
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
  } as BoxProps,
}
